import IletisimList from '../../../components/List/IletisimList'
import Navbar from '../../../components/navbar/Navbar'
import Sidebar from '../../../components/sidebar/Sidebar'

const AdminIletisim = () => {
    return (
        <div className="dashboard">
            <Sidebar />
            <div className="dashboardContainer">
                <Navbar />
                <div className="listContainer">
                    <IletisimList title={"İletisim"} />
                </div>
            </div>
        </div>
    )
}

export default AdminIletisim
